package org.example.project.screens_cus_mobile

import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.service.LoginService
import org.example.project.utils.All

private val mobileStandortFilterJson = Json {
    ignoreUnknownKeys = true
    encodeDefaults = false
}

private fun mobileStandortApiPart(value: String): String =
    js("encodeURIComponent")(if (value.isBlank()) "~" else value) as String

private fun parseMobileStandorte(raw: String): Set<String> =
    raw.split(",")
        .map { it.trim() }
        .filter { it.isNotBlank() }
        .toSet()

suspend fun loadMobileErlaubteStandorte(): Set<String> {
    val user = LoginService.getUser() ?: return emptySet()
    val bereich = user.bereich.trim()
    if (bereich.isBlank()) return emptySet()

    val raw = runCatching {
        LumaticaApiManager.call("bereich/entries/${mobileStandortApiPart(user.id)}")
    }.getOrDefault("")
    if (raw.isBlank()) return emptySet()

    val bereiche = runCatching {
        mobileStandortFilterJson.decodeFromString<List<All>>(raw)
    }.getOrDefault(emptyList())

    val selected = bereiche.firstOrNull {
        it.id == bereich || it.name == bereich || it.bezeichnung == bereich
    } ?: return emptySet()

    return parseMobileStandorte(selected.infraStandorte)
}

fun mobileStandortErlaubt(entry: All, erlaubteStandorte: Set<String>): Boolean {
    if (erlaubteStandorte.isEmpty()) return true
    val standortId = entry.slotStandortId
        .ifBlank { entry.slotAbholort }
        .ifBlank { entry.standort }
        .trim()
    return standortId in erlaubteStandorte
}
